import { newFolderId } from './FolderId';
import type { FolderId, WorkspaceId, FolderJSON } from 'balus-common';

export class Folder {
  static ROOT_ID = '__root__';

  constructor(
    public readonly id: FolderId,
    public readonly name: string,
    public readonly workspaceId: WorkspaceId
  ) {}

  static buildNew(name: string, workspaceId: WorkspaceId): Folder {
    return new Folder(newFolderId(), name, workspaceId);
  }

  static buildRootFolder(workspaceId: WorkspaceId): Folder {
    return new Folder(this.ROOT_ID, '', workspaceId);
  }

  static compare(a: Folder, b: Folder): number {
    return a.compareTo(b);
  }

  compareTo(other: Folder): number {
    const name = this.name.toLowerCase();
    const otherName = other.name.toLowerCase();
    return name.localeCompare(otherName);
  }

  withName(name: string): Folder {
    return new Folder(this.id, name, this.workspaceId);
  }

  dump(): FolderJSON {
    const { id, name, workspaceId } = this;
    return {
      id,
      name,
      workspaceId,
    };
  }

  static load(dump: FolderJSON): Folder {
    const { id, name, workspaceId } = dump;
    return new Folder(id, name, workspaceId);
  }

  isRoot(): boolean {
    return this.id === Folder.ROOT_ID;
  }

  includesMulti(keywords: string[]): boolean {
    return keywords.some((keyword) => {
      if (!keyword) return false;
      return this.name.toLowerCase().includes(keyword.toLowerCase());
    });
  }
}
